<script setup lang="ts">
import { cx } from './cx'

type Tone = 'neutral' | 'accent' | 'ok' | 'warn' | 'danger' | 'info'

const TONES: Record<Tone, string> = {
  neutral: 'bg-raised text-muted border-line',
  accent: 'bg-accent/15 text-accent-dim border-accent/35',
  ok: 'bg-ok/10 text-ok border-ok/25',
  warn: 'bg-warn/10 text-warn border-warn/25',
  danger: 'bg-danger/10 text-danger border-danger/25',
  info: 'bg-link/10 text-link border-link/25',
}

withDefaults(defineProps<{ tone?: Tone }>(), { tone: 'neutral' })
</script>

<template>
  <span
    :class="
      cx(
        'inline-flex items-center gap-1 rounded-sm border px-1.5 py-px text-[11px] font-medium leading-5 whitespace-nowrap',
        TONES[tone],
      )
    "
  >
    <slot />
  </span>
</template>
